import React, { useEffect, useState } from 'react'

import { useContext } from 'react';
import EventContext from '../contexts/EventContext';
import Layout from './Layout';
import { Prompt, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { API_URL } from '../config';
import { Linkedin, LinkedinIcon, Youtube } from 'lucide-react';
import useFetchPartenaireList from '../customHooks/useFetchPartenaireList';
import PromptAi from './PromptAi';

const linkdinProfileUrlList = [
    'https://www.linkedin.com/in/st%C3%A9phane-pierre-castet-3705b133/',
    'https://www.linkedin.com/in/mariana-m-miu05/',
    'https://www.linkedin.com/in/pauline-souques-326b50144/',
    'https://www.linkedin.com/in/marclionel/'];


const Section = ({ children, title }) => {

    return (
        <div className="border-x border-y border-gray-400  rounded-lg mb-3">
            <h2 className="text-xl font-bold text-white bg-neutral-800 p-4 rounded-t-lg">
                {title}
            </h2>
            <div className="p-4">
                {children}
            </div>
        </div>
    );

}


const FicheLivraison = () => {

    const eventContext = useContext(EventContext);

    const { idVideo, idConferencier, idEvent } = useParams();

    const { currentEvent } = eventContext;

    const [video, setVideo] = useState([]);

    const [partenaire, setPartenaire] = useState([]);

    const [videoIsLoading, setVideoIsLoading] = useState(false);
    const [partenaireIsLoading, setPartenaireIsLoading] = useState(false);

    const { data: partenaireData, loading: partenaireLoading, error: partenaireError } = useFetchPartenaireList(`${API_URL}?action=getPartenaires&params= AND id_event=${idEvent} AND cf.statut=143`);

    const getPartenaires = async ({ idConferencier }) => {

        setPartenaireIsLoading(true);
        await fetch(`${API_URL}?action=getPartenaires&params= AND id_conferencier  = ${idConferencier}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setPartenaire(result[0]);
                    setPartenaireIsLoading(false);

                },
                (error) => {
                    console.error(error);
                }
            );
    }

    const getVideoList = async ({ idVideo }) => {

        setVideoIsLoading(true);
        await fetch(`${API_URL}?action=getVideoList&params=WHERE id_video  = ${idVideo}`)

            .then(res => res.json())
            .then(
                (result) => {
                    setVideo(result[0]);
                    setVideoIsLoading(false);
                },
                (error) => {
                    console.error(error);
                }
            );
    };

    const generatePromptForRow = (intervenant) => {

        if (!intervenant || !currentEvent) return "";

        const { contact: { prenom, nom, societe }, presta_nom, punchline } = intervenant;

        return `À l'occasion de "${currentEvent.nom}", peux-tu me rédiger un post LinkedIn afin de valoriser l'interview de ${prenom} ${nom} de la société ${societe} autour du thème "${punchline}", mettant en avant la solution "${presta_nom}".`;
    }


    useEffect
        (() => {
            if (idVideo) {
                getVideoList({ idVideo });
            }

            if (idConferencier) {
                getPartenaires({ idConferencier });
            }

        }, [idVideo, idConferencier]);

    return (
        <Layout className="bg-white p-6">

            <div className="max-w-4xl mx-auto space-y-6">
                <h1 className="text-3xl font-bold text-gray-800 border-b pb-4">Livraison de votre Webcast</h1>

                <p className="text-lg">  {partenaire?.contact?.prenom} {partenaire?.contact?.nom} - {partenaire?.contact?.societe},</p>

                <p className="text-gray-700">Merci encore d’avoir enregistré votre webcast. Vous trouverez ci-dessous toutes les informations utiles pour en maximiser l’audience et l’impact.</p>

                <Section
                    title={`1. Profitez de l'audience en ligne de ${currentEvent?.nom}`}
                >


                    <div className="pl-4 space-y-4">
                        <p>
                            <b>Votre webcast est désormais disponible </b>sur la page ou la chaîne Youtube de l'organisateur :
                        </p>


                        <p><a href={`https://www.youtube.com/watch?v=${video?.id_youtube}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-xl font-bold break-all">https://www.youtube.com/watch?v={video?.id_youtube}</a></p>

                        <p>Pour maximiser sa portée :</p>

                        <ul className="list-disc list-outside ml-6 space-y-3">
                            <li>
                                <b>Abonnez-vous à la chaîne Youtube de l'événement</b> pour suivre les diffusions après l’événement.
                                <a
                                    href={currentEvent?.youtube_channel ? `${currentEvent.youtube_channel}?sub_confirmation=1` : '#'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="ml-4 inline-flex items-center bg-red-600 text-white font-bold py-2 px-4 rounded hover:bg-red-700 transition-colors text-sm"
                                >
                                    <Youtube className="h-5 w-5 mr-2" />
                                    S'abonner
                                </a>
                            </li>
                            <li><b>Repostez le lien Youtube ci-dessus dès maintenant sur vos réseaux sociaux.</b></li>
                            <li>
                                <b>Identifiez dans votre post LinkedIn les acteurs et soutiens ci-dessous</b>. Ils relaieront ainsi votre publication et en amplifieront la portée :
                                <ul className="mt-3 space-y-2">
                                    {linkdinProfileUrlList.map((linkdinProfileUrl, index) => (
                                        <li key={index}>
                                            <a href={linkdinProfileUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="flex space-x-3 items-center rounded-full  w-fit text-blue-600 hover:bg-blue-100 transition-colors text-sm">
                                                <LinkedinIcon className="bg-blue-600 text-white p-1 rounded-sm inline-block" />
                                                <span>{linkdinProfileUrl}</span>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        </ul>
                    </div>
                </Section>


                <Section
                    title="2. Accédez à la vidéo native pour vos besoins">

                    <div className="pl-4 space-y-4">
                        <p>
                            Téléchargez la vidéo native de votre interview via le lien ci-dessous :
                        </p>

                        <p>
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href={video?.download_url}
                                className="text-blue-600 hover:underline text-xl font-bold break-all">
                                {video?.download_url}
                            </a>
                        </p>

                        <p>Quelques usages recommandés de votre vidéo native :</p>

                        <b>1. Adapter librement votre vidéo selon vos besoins. </b>
                        <br /> Vous pouvez :
                        <ul className="list-disc list-outside ml-6">
                            <li>en extraire des séquences,</li>
                            <li>la remonter au format vertical pour Instagram, TikTok ou autre,</li>
                            <li>l'enrichir avec votre charte graphique,</li>
                            <li>l'utiliser dans vos newsletters, présentations ou supports internes.</li>
                        </ul>

                        <p><b>2. Maximiser l'impact sur LinkedIn et X (Twitter) :</b></p>
                        <p>Les plateformes comme LinkedIn privilégient la diffusion de contenus natifs. En complément du lien YouTube, nous vous recommandons de publier directement la vidéo native sur votre compte LinkedIn, celui de votre entreprise et de vos collaborateurs.</p>
                    </div>

                </Section>


                <Section
                    title="3. Bénéficiez de la visibilité de votre animateur myGlobalVillage">

                    <div className="pl-4 space-y-4">
                        <p>Si vous visez de nouveaux marchés (clients finaux, distributeurs, intégrateurs), votre animateur <a href="https://www.linkedin.com/in/marclionel/" className="text-blue-600 hover:underline">Marc-Lionel Gatto</a> (15k abonnés : décideurs innovation, dirigeants internationaux, partenaires export) myGlobalVillage vous offre  une visibilité additionnelle sur son compte Linkedin :</p>
                        <p>➡️ Pour en bénéficier : merci de valider ou d'ajuster ce projet de post :</p>

                        {!partenaireLoading ? <PromptAi
                            displayPrompt={false}
                            profileLinkList={linkdinProfileUrlList}
                            prompt={generatePromptForRow(partenaireData[0])} />

                            : <p>Génération du post en cours...</p>
                        }
                    </div>
                </Section>
            </div>
        </Layout>
    )
}

export default FicheLivraison;